// import 'chosen-js';
// import 'chosen-js/chosen.css';
import AngularComponents from './angularjs/angularImports';

typeof AngularComponents;

window.Vue = require('vue');